import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Preview extends Icon {
  static defaultProps = {
    color: '#FFFFFF',
    size: 16,
    viewPortSize: 18
  };

  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M16.8,8.3C16.6,8,13.1,2,8.5,2C3.9,2,0.4,8,0.2,8.3L0,8.7l0.3,0.4c0.1,0.2,3.7,5.2,8.2,5.2c4.5,0,8.1-5,8.2-5.2L17,8.7
          L16.8,8.3z M8.5,3.5c2,0,3.9,1.6,5.2,3.1c-1.4-0.5-3.2-1-5.2-1c-2,0-3.8,0.5-5.2,1C4.6,5.1,6.5,3.5,8.5,3.5z M8.5,7.3
          c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7S6.8,9.9,6.8,9C6.8,8,7.6,7.3,8.5,7.3z M8.5,12.8c-2.9,0-5.5-2.7-6.5-4
          c0.8-0.4,2.1-1.1,3.8-1.5C5.5,7.9,5.3,8.4,5.3,9c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2c0-0.6-0.2-1.1-0.5-1.6
          c1.7,0.4,3,1.1,3.8,1.5C14,10.1,11.4,12.8,8.5,12.8z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Preview.js